/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssignWorkOrderRequestDto
 */
export interface AssignWorkOrderRequestDto {
    /**
     * 
     * @type {string}
     * @memberof AssignWorkOrderRequestDto
     */
    technicianId: string;
}

/**
 * Check if a given object implements the AssignWorkOrderRequestDto interface.
 */
export function instanceOfAssignWorkOrderRequestDto(value: object): value is AssignWorkOrderRequestDto {
    if (!('technicianId' in value) || value['technicianId'] === undefined) return false;
    return true;
}

export function AssignWorkOrderRequestDtoFromJSON(json: any): AssignWorkOrderRequestDto {
    return AssignWorkOrderRequestDtoFromJSONTyped(json, false);
}

export function AssignWorkOrderRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignWorkOrderRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'technicianId': json['technicianId'],
    };
}

export function AssignWorkOrderRequestDtoToJSON(json: any): AssignWorkOrderRequestDto {
    return AssignWorkOrderRequestDtoToJSONTyped(json, false);
}

export function AssignWorkOrderRequestDtoToJSONTyped(value?: AssignWorkOrderRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'technicianId': value['technicianId'],
    };
}

